import { AttachmentPreviewMethod } from 'owa-attachment-data';
import getAttachment from 'owa-attachment-model-store/lib/selectors/getAttachment';
import getAttachmentFileType from 'owa-attachment-model-store/lib/utils/getAttachmentFileType';
import { getExtensionWithoutDotFromFileName } from 'owa-file';
import fileExtensionToOfficeFileType from 'owa-file/lib/utils/fileExtensionToOfficeFileType';
import { SxSCustomData } from 'owa-sxs';
import PreviewPaneSelectionSource from '../store/schema/PreviewPaneSelectionSource';
import sxsStore from '../store/Store';

export default function getExtraCustomDataForDatapoint(): SxSCustomData {
    const attachmentId = sxsStore.extendedViewState.attachmentId;
    const attachmentModel = attachmentId && getAttachment(attachmentId);
    const fileType =
        (attachmentModel && getAttachmentFileType(attachmentModel)) ||
        (sxsStore.viewState?.previewPane?.fileName &&
            getExtensionWithoutDotFromFileName(sxsStore.viewState.previewPane.fileName));
    return {
        customData: {
            entryPoint: 'SxSCommandBar',
            isCloudy:
                sxsStore.extendedViewState.isCloudy === undefined
                    ? false
                    : sxsStore.extendedViewState.isCloudy,
            isCompose: sxsStore.composeId !== null,
            PreviewMethod: AttachmentPreviewMethod[sxsStore.extendedViewState.previewMode],
            PreviewSource: PreviewPaneSelectionSource[sxsStore.extendedViewState.selectionSource],
            officeFileType: fileExtensionToOfficeFileType(fileType),
            isLink: !sxsStore.extendedViewState.attachmentId,
        },
        cosmosOnlyData: {
            size: attachmentModel && attachmentModel.model.Size,
            attachmentId: attachmentId?.Id,
            fileType: fileType?.substring(0, 4) || '',
        },
    };
}
